// document.addEventListener('DOMContentLoaded', () => {
//     console.log("Page loaded");

//     // Initialize arrays for each filter category
//     let selectedFarbe = [];
//     let selectedLange = [];
//     let selectedMaterial = [];

//     // Function to update selected filters based on which are checked
//     function updateSelectedFilters() {
//         // Clear current arrays
//         selectedFarbe = [];
//         selectedLange = [];
//         selectedMaterial = [];

//         // Find all filters and get values of checked inputs
//         let filters = document.querySelectorAll('.collection__facets form .accordion');

//         filters.forEach(filter => {
//             // Get the checked input inside the filter
//             let checkedInput = filter.querySelector('.accordion__content input:checked');
            

//             if (checkedInput) {
//                 // Get the filter value of the checked input
//                 let filterValue = checkedInput.getAttribute('value').trim().toLowerCase().replace(/\s+/g, '-');

//                 // Directly push the filter value into appropriate array
//                 if (checkedInput.getAttribute('name') == 'filter.v.option.farbe') {
//                     selectedFarbe.push(filterValue);
//                 } else if (checkedInput.getAttribute('name') == 'filter.v.option.länge') {
//                     selectedLange.push(filterValue);
//                 } else if (checkedInput.getAttribute('name') == 'filter.p.m.custom.material_filter_data_') {
//                     selectedMaterial.push(filterValue);
//                 }

//                 console.log('Selected Farbe:', selectedFarbe);
//                 console.log('Selected Länge:', selectedLange);
//                 console.log('Selected Material:', selectedMaterial);
//             }
//         });

//         // After updating arrays, filter the product cards
//         filterProductCards();
//     }

//     // Function to filter product cards based on selected filters
//     function filterProductCards() {
//         let productCards = document.querySelectorAll('.collection__results .product-list .product-card');

//         productCards.forEach(card => {
//             // Get product card handle and split into components
//             let handleComponents = card.getAttribute('handle')?.trim().toLowerCase().replace(/\s+/g, '-').split(' / ');
//             console.log('Handle Components', handleComponents);

//             if (!handleComponents) return; // Skip if no handle is found

//             // Determine if the product matches the selected facets
//             let matchesFarbe = selectedFarbe.length === 0 || selectedFarbe.some(value => handleComponents.includes(value));
//             let matchesLange = selectedLange.length === 0 || selectedLange.some(value => handleComponents.includes(value));
//             let matchesMaterial = selectedMaterial.length === 0 || selectedMaterial.some(value => handleComponents.includes(value));

//             // Show or hide the product card based on whether all facets match
//             if (matchesFarbe && matchesLange && matchesMaterial) {
//                 card.style.display = "block";
//             } else {
//                 card.style.display = "none";
//             }
//         });
//     }

//     // MutationObserver to observe changes in .shopify-section--main-collection
//     const targetNode = document.querySelector('.shopify-section--main-collection');
//     if (targetNode) {
//         const observerConfig = { childList: true, subtree: true };

//         const observerCallback = debounce(() => {
//             console.log('DOM changes detected in .shopify-section--main-collection');
//             setTimeout(updateSelectedFilters, 100); // Update filters when DOM changes
//         }, 50); // Debounce delay

//         const observer = new MutationObserver(observerCallback);
//         observer.observe(targetNode, observerConfig);
//     } else {
//         console.error('.shopify-section--main-collection not found');
//     }

//     // Initial check for existing filters and product cards
//     updateSelectedFilters();

//     // Debounce function to limit how often a function is called
//     function debounce(func, wait) {
//         let timeout;
//         return function() {
//             clearTimeout(timeout);
//             timeout = setTimeout(() => {
//                 func();
//             }, wait);
//         };
//     }
// });

//     document.addEventListener('DOMContentLoaded', (event) => {
//       console.log("Filtering logic initialized");
//       function getCheckedValues(name) {
//         // Select all checked checkboxes with the name provided
//         const checkedCheckboxes = document.querySelectorAll('input[name="'+name+'"]:checked');
        
//         // Map over the NodeList and get the unique values from the `data-val` attribute of the checked checkboxes
//         const checkedValues = [...new Set(Array.from(checkedCheckboxes).map(checkbox => checkbox.getAttribute('data-val')))];
        
//         return checkedValues;
//     }

//     // Function to get selected facets by category (color, size, etc.)
//     function getSelectedFacetsByCategory() {
//       // Map over the NodeList and get the unique values of the checked checkboxes
//       const Colors = getCheckedValues('filter.v.option.farbe');
//       const lengths = getCheckedValues('filter.v.option.länge');
//       const materials = getCheckedValues('filter.p.m.custom.material_filter_data_');
      
//       console.log('Colors:', Colors);
//       console.log('Length:', lengths);
//       console.log('material:', materials);
      
//       var mixedValue = [];
//       Colors.forEach(function(color) {
//           lengths.forEach(function(length) {
//             materials.forEach(function(material) {
//               mixedValue.push(color + "/" + length + "/" + material);
//             });
//           });
//       });
       
//       console.log('Combined:', mixedValue);
//       let selectedFacetsByCategory = {};
//     }

//     function doesVariantMatchFilters(variantHandle, selectedFacetsByCategory) {
//         let handleComponents = variantHandle.trim().toLowerCase().replace(/\s+/g, '-').split(' / '); // Split variant handle

//     }

//     // Function to filter and show/hide variants based on the selected facets
//     function filterVariantsByActiveFacets() {
//         let selectedFacetsByCategory = getSelectedFacetsByCategory(); // Get selected filters

//         // Get all variant cards on the page
//         let variantCards = document.querySelectorAll('.collection__results .product-list .product-card');

//         // Loop through all variant cards to check if they match the filters
//         variantCards.forEach(card => {
//             let variantHandle = card.getAttribute('handle'); // Get the handle of the variant

//             // Check if the variant matches all active filters
//             let matches = doesVariantMatchFilters(variantHandle, selectedFacetsByCategory);

//             // Show or hide the card based on whether it matches
//             //card.style.display = matches ? "block" : "none";
//         });
//    }

//     // Function to check if there are active facets (filters applied by the user)
//     function checkForActiveFacets() {
//         const activeFacets = document.querySelectorAll('.facets-summary .active-facets .removable-facet');
//         if (activeFacets.length > 0) {
//             filterVariantsByActiveFacets(); // Apply filtering when facets are active
//         }
//         console.log(activeFacets);
//     }

//     // Debounce function to limit how often checkForActiveFacets is called
//     function debounce(func, wait) {
//         let timeout;
//         return function() {
//             clearTimeout(timeout);
//             timeout = setTimeout(() => {
//                 func();
//             }, wait);
//         };
//     }

//     // MutationObserver to detect changes in the collection page (new products loaded, filters applied)
//     const targetNode = document.querySelector('.shopify-section--main-collection');
//     if (targetNode) {
//         const observerConfig = { childList: true, subtree: true };

//         const observerCallback = debounce(() => {
//             console.log('Detected changes in the collection section');
//             setTimeout(checkForActiveFacets, 100);
//         }, 50); // Debounce delay

//         const observer = new MutationObserver(observerCallback);
//         observer.observe(targetNode, observerConfig);
//     } else {
//         console.error('.shopify-section--main-collection not found');
//     }

//     // Initial check for existing active facets
//     checkForActiveFacets();

// });

document.addEventListener('DOMContentLoaded', (event) => {
  console.log("Filtering logic initialized");

  // Function to get checked values from checkboxes with the given name
  function getCheckedValues(name) {
    const checkedCheckboxes = document.querySelectorAll('input[name="'+name+'"]:checked');
    const checkedValues = [...new Set(Array.from(checkedCheckboxes).map(checkbox => checkbox.getAttribute('data-val')))];
    return checkedValues;
  }

  // Dynamic list of filter names (adjust or add more if necessary)
  const filterNames = [
    'filter.v.option.farbe',
    'filter.v.option.länge',
    'filter.p.m.custom.grip_filter_option',
    'filter.p.m.custom.material_filter_data_',
    'filter.v.option.gewicht',
    'filter.v.m.custom.barrel_diameter_filter',
    'filter.v.m.custom.barrel_length_filter',
    'filter.p.m.custom.balance_filter_data',
    'filter.p.m.custom.grip_strength_filter_data',
    'filter.p.m.custom.shape_filter_data',
    'filter.p.m.custom.grip_type_filter_data',
    'filter.v.option.stärke',
    'filter.p.m.custom.shape_filter_data'
  ];

  // Function to dynamically get selected facets by category
  function getSelectedFacetsByCategory() {
    let selectedFilters = [];

    // Iterate over each filter name and collect the checked values
    filterNames.forEach(filterName => {
      const checkedValues = getCheckedValues(filterName);
      if (checkedValues.length > 0) {
        selectedFilters.push(checkedValues);
      }
    });

    let mixedValue = [];

    // Create combinations dynamically based on selected filters
    if (selectedFilters.length === 0) {
      return null; // No filters selected
    }

    // Recursively combine selected filter values
    function combineFilters(index, currentCombination) {
      if (index === selectedFilters.length) {
        mixedValue.push(currentCombination);
        return;
      }

      selectedFilters[index].forEach(selectedValue => {
        const newCombination = currentCombination ? currentCombination + "/" + selectedValue : selectedValue;
        combineFilters(index + 1, newCombination);
      });
    }

    combineFilters(0, "");

    console.log('Combined:', mixedValue);
    return mixedValue;
  }

  // Function to standardize the handle and combination by replacing special characters
  function cleanValueForComparison(value) {
    return value
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')          // Replace spaces with hyphens
      .replace(/[()]/g, '-')         // Replace parentheses with hyphens
      .replace(/--+/g, '-')          // Replace multiple hyphens with a single one
      .replace(/[^a-z0-9-]+/g, '-')  // Replace any special characters with hyphens
      .replace(/^-|-$/g, '');        // Remove leading or trailing hyphens
  }
  
  // Function to split the string into components for more robust matching
  function splitIntoComponents(value) {
    return cleanValueForComparison(value).split('-');
  }

    // Function to check if any index of mixedValue contains data from handleComponents
  function doesVariantMatchFilters(variantHandle, mixedValue) {
    // Remove all '/' from the variantHandle and mixedValue for comparison
    let cleanVariantHandle = splitIntoComponents(variantHandle);
    
    // Loop through mixedValue and check if any of its index is contained in the handle
    return mixedValue.some(combination => {
      // Clean the combination by removing slashes and spaces for comparison
      let cleanCombination = splitIntoComponents(combination);
      
      // Check if every component in the combination exists in the handle components
      const matches = cleanCombination.every(component => cleanVariantHandle.includes(component));
      return matches;
    });
  }

  // Function to filter and show/hide variants based on selected facets
  function filterVariantsByActiveFacets() {
    const mixedValue = getSelectedFacetsByCategory(); // Get selected filters

    const variantCards = document.querySelectorAll('.collection__results .product-list .product-card');

    if (!mixedValue) {
      variantCards.forEach(card => {
        card.style.display = "block"; // Show all cards
      });
      return; // Exit function if no filters are selected
    }

    // Loop through all variant cards to check if they match the filters
    variantCards.forEach(card => {
      const variantHandle = card.getAttribute('handle'); // Get the handle of the variant

      // Check if the variant matches any of the selected facet combinations
      const matches = doesVariantMatchFilters(variantHandle, mixedValue);

      // Show or hide the card based on whether it matches the filters
      card.style.display = matches ? "block" : "none";
    });
  }


  // Function to check for active facets and trigger filtering
  function checkForActiveFacets() {
    filterVariantsByActiveFacets(); // Apply filtering based on the selected facets
  }

  // Debounce function to limit how often checkForActiveFacets is called
    function debounce(func, wait) {
        let timeout;
        return function() {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func();
            }, wait);
        };
    }

  // MutationObserver to detect changes in the collection page (optional - already implemented in your original code)
  const targetNode = document.querySelector('.shopify-section--main-collection');
  if (targetNode) {
    const observerConfig = { childList: true, subtree: true };

    const observerCallback = debounce(() => {
      console.log('Detected changes in the collection section');
      setTimeout(checkForActiveFacets, 100);
    }, 50); // Debounce delay

    const observer = new MutationObserver(observerCallback);
    observer.observe(targetNode, observerConfig);
  } else {
    console.error('.shopify-section--main-collection not found');
  }

  // Initial check for existing active facets
  checkForActiveFacets();
});


document.addEventListener('DOMContentLoaded', () => {
    function showFilters() {
        let filtersName = document.querySelector('.collection-filters-name').value;
        //console.log('filtersName', filtersName);
        let filtersNameArray = filtersName.split(',').map(name => name.trim().toLowerCase());
        
        let filters = document.querySelectorAll('.collection__facets details.accordion');
        filters.forEach(filter => {
            let name = filter.querySelector('summary .accordion__toggle > span:nth-child(1)').textContent.trim().toLowerCase();
    
            if (name === 'farbe' || filtersNameArray.includes(name)) {
                filter.style.display = 'block';
            } else {
                filter.style.display = 'none';
            }
        });
    }

    showFilters();

    // MutationObserver to observe changes in .shopify-section--main-collection
    const targetNode = document.querySelector('.shopify-section--main-collection');
    if (targetNode) {
        const observerConfig = { childList: true, subtree: true };

        const observerCallback = function(mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    // console.log('DOM changes detected in .shopify-section--main-collection');
                    showFilters();
                }
            }
        };

        const observer = new MutationObserver(observerCallback);
        observer.observe(targetNode, observerConfig);
    } else {
        console.error('.shopify-section--main-collection not found');
    }
});
